module.exports = __webpack_public_path__ + "img/5hearts.16ae4b1c.jpg";